import React from 'react';
import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('token');
    navigate('/');
  };

  const home = () => {
    navigate('/');
  };

  return (
    <div
      className="d-flex"
      style={{
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
      {/* <img src={Logo} alt="" style={{ width: '100px' }} onClick={home} /> */}
      <h1 onClick={home} style={{ color: '#006926' }}>
        Hệ thống tra cứu hoá đơn{' '}
      </h1>
      <div style={{ marginTop: '20px' }}>
        <h1 style={{ color: '#006926' }}>
          CÔNG TY CỔ PHẦN NƯỚC VÀ MÔI TRƯỜNG BÌNH TÂN
        </h1>
        <p>Mã số thuế: 1501012456</p>
        <p>Địa chỉ: 3530 Ấp Thành Phú, Xã Tân Quới, Tỉnh Vĩnh Long</p>
        <p>Điện thoại: 0270.3753368 - 0270.3550636</p>
      </div>
    </div>
  );
}

export default Header;
